var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M36 36a3 3 0 0 0 3-3v-7.326a3 3 0 0 0-3-3h-4.163q0-1.581.186-3.162.279-1.675.93-2.976.65-1.303 1.676-2.049 1.021-.837 2.605-.837V9q-2.605 0-4.56 1.116a10 10 0 0 0-3.255 2.976 14.8 14.8 0 0 0-1.86 4.374A23 23 0 0 0 27 22.674V33a3 3 0 0 0 3 3zm-18 0a3 3 0 0 0 3-3v-7.326a3 3 0 0 0-3-3h-4.164q0-1.581.187-3.162.28-1.675.93-2.976.65-1.303 1.677-2.049 1.02-.837 2.604-.837V9q-2.605 0-4.56 1.116a10 10 0 0 0-3.255 2.976 14.8 14.8 0 0 0-1.86 4.374A23 23 0 0 0 9 22.674V33a3 3 0 0 0 3 3z","fill":"#307ACB"}));
}

Quote.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Quote;

Quote.default = Quote;
